import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { message } from "antd";
import axiosHttp from "services/axiosHttp";

export const createLicense = createAsyncThunk("createLicense", async ({ data, form }) => {
	const payload = {
		productName: data.productName,
		vendor: data.vendor,
		licenseKey: data.licenseKey || null,
		totalSeats: Number(data.totalSeats),
		expiryDate: data.expiryDate ? data.expiryDate.format("YYY-MM-DD") : null,
		notes: data.notes || null,
		companyId: Number(data.companyId),
		assetTypeId: Number(data.assetTypeId),
		categoryId: Number(data.categoryId)
	};

	const response = await axiosHttp.post(`assets/licenses`, payload);
	form.resetFields();
	message.success("Software License created suceesfully!");
	return response.data?.data ?? response.data;
});

const LicenseCreateSlice = createSlice({
	name: "licenseCreateSlice",
	initialState: { isLoading: false, error: null },
	extraReducers: (builder) => {
		builder
		.addCase(createLicense.pending, (state) => { state.isLoading = true; })
		.addCase(createLicense.fulfilled, (state) => { state.isLoading = false; })
		.addCase(createLicense.rejected, (state, action) => { state.isLoading = false; state.error = action.payload; });
	},
});

export default LicenseCreateSlice.reducer;
